export default __webpack_public_path__ + "static/media/fortress-logo.1c04aa2a.png";